"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ".textWithSyllabification {\n  hyphens: auto;\n  overflow-wrap: anywhere;\n  -webkit-hyphens: auto; }\n";
  const fileName = "TextWithSyllabification_TextWithSyllabification";
  const element = document.querySelector("style[data-sass-component='TextWithSyllabification_TextWithSyllabification']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
function TextWithSyllabification(_ref) {
  let {
    lang,
    children = '',
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    lang: lang,
    className: 'textWithSyllabification ' + (className ? className : ''),
    dangerouslySetInnerHTML: {
      __html: children.replace('<p>', '').replace('</p>', '')
    }
  });
}
TextWithSyllabification.protoTypes = {
  lang: _propTypes.default.string.isRequired
};
TextWithSyllabification.defaultProps = {
  lang: 'de'
};
var _default = exports.default = TextWithSyllabification;